import { render } from "./plus-circle.svg?vue&type=template&id=05dd62f0?inline"
const script = {}
script.render = render

export default script